import { addressSchema } from '@biteinc/schemas';

app.AddressFieldView = app.NestedObjectFieldView.extend({
  getNestedObjectSchema() {
    return addressSchema;
  },
});
